import React from "react";

import { TagType, _Tag } from "./_Tag";

export function SuccessTag({
  type = "bold",
  testID = "success-tag",
  ...props
}: TagType) {
  if (type === "bold")
    return (
      <_Tag
        fill="background-accent-green-strong"
        color="text-inverse"
        testID={testID}
        {...props}
      />
    );

  return (
    <_Tag
      fill="background-accent-green-weak"
      color="text-accent-green-strong"
      testID={testID}
      {...props}
    />
  );
}
